<template>
    <main role="main" class="container text-center">
        <h1>Sign In</h1>
        <notices :errors="errors" :notices="notices"></notices>
        <div class="row justify-content-md-center">
        </div>
        <div class="row justify-content-md-center container-fluid">
            <form class="form-inline">
                <input v-model="input.email" id="form-email" class="form-control m-2" placeholder="Email address">
                <b-button type="button" class="btn btn-primary m-2" v-on:click="emailLogin()" :disabled="formCompleted">Sign in with email link</b-button><br/>
            </form>
        </div>
        <br/>
        <div class="row justify-content-md-center">
                <div class="col-md-3"> 
                    <button class="btn btn-lg btn-google btn-block text-uppercase btn-outline" v-on:click="googleSignIn()"><img src="https://img.icons8.com/color/16/000000/google-logo.png"> Signin Using Google</button>
                </div>
        </div>
        <div class="row justify-content-md-center">
            <div>or <router-link to="/register">Create Account</router-link></div>
        </div>
    </main>
</template>

<script>
import axios from 'axios';
import Notices from '../components/Notices.vue';
import AppConfig from '../util/config';

export default {
    components: { Notices },
    name: 'Login',
    data() {
        return {
            errors: [],
            notices: [],
            input: {
                email: "",
            },
            formCompleted: false
        }
    },
    methods: {
        googleSignIn() {
            this.errors = [];
            var self = this;
            this.$gAuth.signIn()
                .then((resp) => {
                    var email = resp.getBasicProfile().getEmail();
                    var authToken = resp.getAuthResponse().id_token;
                    if (email && authToken) {
                        var config = {
                            params: {
                                "token": authToken,
                                "email": email
                            }
                        }
                        axios.get(AppConfig.BACKEND_ENDPOINT + "/auth/authorize/google", config)
                        .then((result) => {
                            console.log(result.data.data.token);
                            document.cookie = "token=" + result.data.data.token;
                            self.$emit("authenticated", true);
                            self.$router.replace({ name: "dashboard" });
                        }).catch(e => {
                            console.log(e);
                            if (e.response.status === 403) {
                                self.$emit("authenticated", false);
                                self.$router.replace({ name: "home" });
                            } else if (e.response.status == 503) {
                                self.errors.push("There was an internal error. Please try again in a while.");
                            } else {
                                self.errors.push(e.response.data.error);
                            }
                        }) 
                    } 
                })
                .catch(() => {
                    self.errors.push("Uh-oh lools there was an issue with authentication.");
                });
        },
        login() {
            this.errors = [];

            if (this.$route.query.token && this.$route.query.email) {
                var self = this;
                var token = this.$route.query.token;
                var email = this.$route.query.email;
                var config = {
                    params: {
                        "token": token,
                        "email": email
                    }
                };
                axios.get(AppConfig.BACKEND_ENDPOINT + "/auth/authorize", config)
                .then(() => {
                    document.cookie = "token=" + token;
                    self.$emit("authenticated", true);
                    self.$router.replace({ name: "dashboard" });
                    self.formCompleted = true;
                }).catch(e => {
                    console.log(e);
                    if (e.response.status === 403) {
                        self.$emit("authenticated", false);
                        self.$router.replace({ name: "home" });
                    } else if (e.response.status == 503) {
                        self.errors.push("There was an internal error. Please try again in a while.");
                    } else {
                        self.errors.push(e.response.data.error);
                    }
                }) 
            }
        },
        validateForm() {
            this.errors = [];
            this.input.email = this.input.email.trim()

            var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!re.test(this.input.email)) {
                this.errors.push("Email address is invalid");
            }

            if (!this.errors.length) { return true; }
            return false

        },
        emailLogin() {
            this.notices = [];
            this.errors = [];
            if (!this.validateForm()) { window.scrollTo(0,0); return; }

            var config = {
                params: {
                    "email": this.input.email
                }
            };
            axios.get(AppConfig.BACKEND_ENDPOINT + "/auth/login", config).then(result => {
                console.log(result.data);
                this.input = {};
                this.notices.push("Access link has been sent to your email address.");
            }).catch(e => {
                console.log(e);
                this.errors.push(e.response.data.error);
            }) 
        }
    },
    mounted() {
        this.login();
        this.renderButton();
    }
}
</script>

<style scoped>
.btn-google {
    color: #545454;
    background-color: #ffffff;
    box-shadow: 0 1px 2px 1px #ddd
}
.btn {
    border-radius: 2px;
    font-size: 15px;
    padding: 10px 19px;
    cursor: pointer
}
.btn-md {
    padding: 10px 16px;
    font-size: 15px;
    line-height: 23px
}

.btn-primary {
    background-color: #4099ff;
    border-color: #4099ff;
    color: #fff;
    cursor: pointer;
    -webkit-transition: all ease-in .3s;
    transition: all ease-in .3s
}
</style>